import { useCallback } from 'react'

export const usePublicRequest = publicApiCall => useCallback((_, parameters) => publicApiCall(parameters), [])
